import {
  Box,
  Text,
  Stack,
  HStack,
  Badge,
  Avatar,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { ModalBono } from "./ModalBono";

export function BonoPayment(props) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <ModalBono
        isOpen={isOpen}
        onClose={(refresh) => {
          onClose();
          refresh === true && props.onAction(refresh);
        }}
        usersList={[
          {
            id: props.bonoId,
            name: props.bonoUser.name,
            surname1: props.bonoUser.surname1,
            surname2: props.bonoUser.surname2,
            avatar: props.bonoUser.avatar,
          },
        ]}
        bonoPayment={{
          bonoId: parseInt(props.bonoId),
          paymentDate: parseInt(props.bonoTypeId),
          discount: parseFloat(props.bonoDiscount).toFixed(2),
          pvp: parseFloat(props.bonoPvp).toFixed(2),
          total: parseFloat(props.bonoTotal).toFixed(2),
        }}
        returnFocusOnClose={false}
      />
      <Box m="auto" w="100%" onClick={onOpen} className="prevent-select">
        <HStack
          m="auto"
          role={"group"}
          p={4}
          bg="white"
          boxShadow={"sm"}
          spacing={2}
          w="100%"
          cursor={"pointer"}
          pl={4}
        >
          <Avatar
            size="xl"
            src={props.bonoUser.avatar}
            name={`${props.bonoUser.name} ${props.bonoUser.surname1}`.trim()}
          />

          <Stack mt={0} pl={2.5} textAlign={"left"} spacing={1}>
            <Text
              fontFamily={"Oswald"}
              fontWeight="500"
              fontSize="2xl"
              color="black"
            >
              {props.bonoType}
            </Text>
            <Badge
              variant="outline"
              colorScheme="blue"
              width={"fit-content"}
              borderRadius={0}
              fontWeight={500}
            >
              {props.bonoUser.name + " " + props.bonoUser.surname1}
            </Badge>
            <Stack fontWeight={400} fontSize={"sm"} spacing={-0.5} mt={1}>
              <Text>
                Importe: <b>{props.bonoTotal.toFixed(2)}€</b>{" "}
                {parseFloat(props.bonoDiscount) !== 0 &&
                  "(-" + props.bonoDiscount + "%)"}
              </Text>
            </Stack>
          </Stack>
        </HStack>
      </Box>
    </>
  );
}
